<template>
	<div
		v-if="initializing"
		:tabindex="0"
		class="cog-field__placeholder cog-input cog-lookup--loading"
		:class="{'is-read-only': readonly}"
		@focus="handleFocus"
		@blur="handleBlur"
	>
		<div class="cog-field__placeholder-inner">
			<!-- The nbsp is to emulate the space of a real input -->
			&nbsp;
			<i-cog />
		</div>
	</div>
	<div v-else class="cog-choice cog-lookup">
		<!-- Lack of whitespace in line below is necessary for :empty CSS to work -->
		<div class="cog-lookup__slot-container cog-choice-option"><slot :value="slot" :choice-options="choiceOptions"></slot></div>
	</div>
</template>

<script>
	import '../style/_motion.scss';

	import CLookup from './Lookup';
	export default CLookup;
</script>

<style lang="scss">
#{$specificity-base} {

	.cog-lookup {

		&--loading {

			&:focus {
				box-shadow: inset 0 0 0 var(--input__border-width) hsla(var(--background-hsl), 1);
			}
		}

		&__slot-container {
			display: contents;
		}
	}
}
</style>